export const WITHOUT_CUSTOMER_ITEM_ID = "__none__";
